import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/gameCard.css';
// helpers
import {getText} from '../../../../helpers/localization';
import {getModuleFromEventType} from '../../../../helpers/moduleHelpers';
import {
    calculateTimeDifference,
    formatTimeInSecondsToMMSS,
    formatTimeToHHMM
} from '../../../../helpers/helperFunctions';
// components
//TODO remove mobile components
import MessageBar from '../../sharedComponents/components/messageBar';
import RaceCard from '../modules/racing/containers/raceCard';
import MatchCard from '../modules/football/containers/matchCard';
import ActiveBetsResume from '../../sharedComponents/components/activeBetsResume';
// constants
import {
    AMERICAN_FOOTBALL_MODULE,
    BASKETBALL_MODULE,
    FOOTBALL_MODULE,
    RACING_MODULE
} from '../../../../constants/identifiers';
import {EXACTA, PLACE, SHOW, TRIFECTA, WIN} from '../../modules/racing/constants/identifiers';
// actions
import {selectEvent} from '../../../../actions/eventsActions';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedEventId: state.vpp.selectedEventId,
        events: state.vpp.events,
        isDesktopMode: state.vpp.isDesktopMode,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        selectedFootballBetType: state.vpp.selectedFootballBetType,
        openBetsHistory: state.vpp.openBetsHistory,
        openBetsList: state.vpp.openBetsList,
        selectedGameIndex: state.vpp.selectedGameIndex,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        selectedChip: state.vpp.selectedChip,
        isBoxBetsButtonToggled: state.vpp.isBoxBetsButtonToggled,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        placedBets: state.vpp.placedBets,
        games: state.vpp.games
    };
};

class GameCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedEventId: storeData.vpp.selectedEventId,
            events: storeData.vpp.events,
            isDesktopMode: storeData.vpp.isDesktopMode,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            selectedFootballBetType: storeData.vpp.selectedFootballBetType,
            openBetsHistory: storeData.vpp.openBetsHistory,
            openBetsList: storeData.vpp.openBetsList,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            selectedChip: storeData.vpp.selectedChip,
            isBoxBetsButtonToggled: storeData.vpp.isBoxBetsButtonToggled,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            placedBets: storeData.vpp.placedBets,
            games: storeData.vpp.games
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedEventId: storeData.vpp.selectedEventId,
                events: storeData.vpp.events,
                isDesktopMode: storeData.vpp.isDesktopMode,
                selectedRacingBetType: storeData.vpp.selectedRacingBetType,
                selectedFootballBetType: storeData.vpp.selectedFootballBetType,
                openBetsHistory: storeData.vpp.openBetsHistory,
                openBetsList: storeData.vpp.openBetsList,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                selectedChip: storeData.vpp.selectedChip,
                isBoxBetsButtonToggled: storeData.vpp.isBoxBetsButtonToggled,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                placedBets: storeData.vpp.placedBets,
                games: storeData.vpp.games
            });
        }
    }

    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: calculateTimeDifference(new Date(), this._getNextEventTime(0)) / 1000,
            secondEventTimeLeft: calculateTimeDifference(new Date(), this._getNextEventTime(1)) / 1000
        });
    }

    _getNextEventTime(eventIndex) {
        let store = this.props.store;
        let storeData = store.getState();
        let eventTime = new Date();
        let event;
        if (this.state && this.state.nextEventsTimeStamp && storeData.vpp.events && storeData.vpp.events.length) {
            event = this.state.nextEventsTimeStamp.find(
                (evt) => evt.channel === storeData.vpp.events[eventIndex].channel && evt.eventId === storeData.vpp.events[eventIndex].eventId
            );
            if (event) {
                eventTime = Number(event.eventTime);
            }
        }

        return eventTime;
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();

        let selectedEvent = (this.state.events && this.state.events.length)
            ? this.state.events[this.state.selectedEventIndex]
            : undefined;
        let gameCard;

        if (selectedEvent) {
            if (selectedEvent.eventTimeDate < new Date().getTime()) {
                let selectedEventId = selectedEvent.eventId;
                let selectedEventChannel = selectedEvent.channel;
                let placedBets = storeData.vpp.placedBets !== undefined
                    ? storeData.vpp.placedBets
                    : [];
                let eventActiveBets = [];
                if (placedBets && placedBets.length) {
                    eventActiveBets = placedBets.slice();
                    eventActiveBets = eventActiveBets.filter((aBet) => {
                        let exists = aBet.Bets.find((bet) => {
                            let eventBetExists = Number(bet.EventId) === selectedEventId && bet.Channel === selectedEventChannel;
                            return eventBetExists;
                        });
                        return exists !== undefined;
                    });
                }
                gameCard = (<ActiveBetsResume activeBets={eventActiveBets} store={this.props.store}/>);
            } else {
                switch (getModuleFromEventType(selectedEvent.eventType)) {
                    case RACING_MODULE:
                        switch (this.state.selectedRacingBetType) {
                            case WIN:
                            case PLACE:
                            case SHOW:
                                gameCard = (<RaceCard id='racingCard' store={this.props.store}/>);
                                break;
                            case EXACTA:
                            case TRIFECTA:
                                gameCard = (<RaceCard id='racingCard' store={this.props.store}/>);
                                break;
                            default:
                                gameCard = '';
                                break;
                        }
                        break;
                    case FOOTBALL_MODULE:
                        gameCard = (<MatchCard id='resultCard' store={this.props.store}/>);
                        break;
                    case BASKETBALL_MODULE:
                        gameCard = (<MatchCard id='resultCard' store={this.props.store}/>);
                        break;
                    case AMERICAN_FOOTBALL_MODULE:
                        gameCard = (<MatchCard id='resultCard' store={this.props.store}/>);
                        break;
                    default:
                        gameCard = (<div></div>);
                        break;
                }
            }
        }

        let blinkingColor = () => {
            let timeLeft = Math.floor(this.state.timeLeft);
            if (timeLeft < 0) {
                return '';
            } else if (timeLeft <= 20) {
                return style.blinkingRed;
            } else if (timeLeft <= 40) {
                return style.blinkingAmber;
            } else {
                return '';
            }
        };

        let noMoreBetsOverlay;
        if (selectedEvent) {
            let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
            for (let i = 0; i < storeData.vpp.noMoreBetsEventList.length; i++) {
                if (storeData.vpp.noMoreBetsEventList[i].eventId === selectedEvent.eventId && storeData.vpp.noMoreBetsEventList[i].gameChannel === selectedGame.channel && selectedEvent.eventTimeDate >= new Date().getTime()) {
                    noMoreBetsOverlay = (
                        <div className={style.noMoreBetsOverlay}>
                            <div className={style.noMoreBetsText} id={'noMoreBetsText'}>
                                {getText('NO_MORE_BETS', this.props.store)}
                            </div>
                        </div>
                    );
                    break;
                }
            }
        }

        let gameDisabledOverlay;
        if (selectedEvent) {
            if (storeData.vpp.games[storeData.vpp.selectedGameIndex].enabled.toString() === 'false') {
                gameDisabledOverlay = (
                    <div className={style.noMoreBetsOverlay}>
                        <div className={style.noMoreBetsText} id={'gameDisabled'}>
                            {getText('GAME_DISABLED', this.props.store)}
                        </div>
                    </div>
                );
            }
        }

        let overlay = gameDisabledOverlay
            ? gameDisabledOverlay
            : noMoreBetsOverlay;

        return (
            <div className={style.raceCardContainer}>
                <div className={style.firstBar}>
                    <div className={style.infoBar}><MessageBar store={this.props.store}/></div>
                    <div className={style.nextRaceContainer}>
                        <div
                            className={`${style.nextRaceButton} ${this.state.selectedEventIndex === 0
                                ? style.selected
                                : ''}`}
                            onClick={() => this.props.store.dispatch(selectEvent(0))}
                            id={'current_race_tab'}>
                            <div className={`${style.nextRaceButtonValue} ${blinkingColor()}`}>{
                                (this.state.timeLeft > 0 || this.state.events.length === 0)
                                    ? this.state.events.length === 0
                                        ? '-- : --'
                                        : formatTimeInSecondsToMMSS(this.state.timeLeft)
                                    : getText('LIVE', store)
                            }</div>
                        </div>
                        <div
                            className={`${style.nextRaceButton} ${this.state.selectedEventIndex === 1
                                ? style.selected
                                : ''}`}
                            onClick={() => this.props.store.dispatch(selectEvent(1))}
                            id={'next_race_tab'}>
                            <div className={style.nextRaceButtonValue}>{
                                this.state.events.length <= 1
                                    ? '-- : --'
                                    : formatTimeToHHMM(this._getNextEventTime(1))
                            }</div>
                        </div>
                    </div>
                </div>
                <div className={style.raceCardContent}>{overlay}
                    <div className={style.gameCardContainer}>{gameCard}</div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(GameCard);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/desktop/containers/gameCard.js